// src/features/eventos/components/EventosToolbar.js
import React from "react";
import styles from "../styles/eventos.module.css";

export function EventosToolbar({
    busqueda,
    setBusqueda,
    orden,
    setOrden,
    resultados,
    estadoTiempo,
    setEstadoTiempo,
}) {
    return (
        <div className={styles["search-bar"]}>
            {setEstadoTiempo && (
                <div className={styles["estado-tabs"]} style={{ display: "flex", gap: 8, marginBottom: 10, width: "100%" }}>
                    <button
                        type="button"
                        onClick={() => setEstadoTiempo("pendientes")}
                        className={estadoTiempo === "pendientes" ? styles.active : ""}
                        style={{
                            padding: "6px 14px",
                            borderRadius: 999,
                            border: "1px solid #ccc",
                            background: estadoTiempo === "pendientes" ? "#455E1D" : "#fff",
                            color: estadoTiempo === "pendientes" ? "#fff" : "#333",
                            cursor: "pointer",
                        }}
                    >
                        Pendientes
                    </button>
                    <button
                        type="button"
                        onClick={() => setEstadoTiempo("pasados")}
                        className={estadoTiempo === "pasados" ? styles.active : ""}
                        style={{
                            padding: "6px 14px",
                            borderRadius: 999,
                            border: "1px solid #ccc",
                            background: estadoTiempo === "pasados" ? "#455E1D" : "#fff",
                            color: estadoTiempo === "pasados" ? "#fff" : "#333",
                            cursor: "pointer",
                        }}
                    >
                        Pasados
                    </button>
                </div>
            )}

            <input
                type="text"
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                placeholder="Buscar por persona, habitación, menú, vino, actividad, estado (provisional/definitivo), fechas..."
                className={styles["search-input"]}
            />

            {busqueda && (
                <button
                    type="button"
                    className={styles["search-clear"]}
                    onClick={() => setBusqueda("")}
                    aria-label="Limpiar búsqueda"
                >
                    Limpiar
                </button>
            )}

            <span className={styles["search-count"]}>
                {busqueda ? `${resultados} resultado(s)` : null}
            </span>

            <div className={styles["order-bar"]}>
                <label>
                    <select value={orden} onChange={(e) => setOrden(e.target.value)}>
                        <option value="fechaAsc">Fecha (más próximo primero)</option>
                        <option value="fechaDesc">Fecha (más lejano primero)</option>
                        <option value="nombreAsc">Nombre (A-Z)</option>
                        <option value="nombreDesc">Nombre (Z-A)</option>
                    </select>
                </label>
            </div>
        </div>
    );
}
